module.exports = __webpack_public_path__ + "8f741c97da480f3a0951228675837d73.pdf";